export const contractAddress = "0xB5013d3DdCE79B31cD44865a9191f4bC0D368444";
export const leaderboardContractAddress = "0x667AEB3113F7deb4c1B2141BC41e7D6A2aa68f83";
export const hypeRaceLeaderboardContractAddress = "0x2Bf67d87bf2Fb0385C5D62599cd1980DD599c750";
export const wethContractAddress = "0x08abc5eA861ACcC2e1a8219Aab3B4BC919c457df";
export const gasGiftingContractAddress = "0xD519b3a1Cb8095f91B76F474E12D0dEd1C4A1853";
export const mainnetContractAddress = "0xF4F5668e72B56FB513a8e974c6Bf883460199424";
export const mainnetGasGiftingContractAddress = "0x499dE5F45aDAcB9a8d5616De219742Bb09b886CD";
export const mainnetWethContractAddress = "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"